export default {"src":"/_next/static/media/telegram.6a3b39f0.svg","height":82,"width":81,"blurWidth":0,"blurHeight":0};